module.exports = "<router-outlet>\n</router-outlet>\n<div style=\"font-family: serif;font-size: 10px; position: absolute;bottom: 2px;left: 2px;z-index: 5;color: white; \">\n  <span>\n    Version : {{v}}\n  </span>\n  \n</div>"


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/iPOSERP/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main